/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createCompanyRegistrationSummaryFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, type CompanyRegistrationSummary, type ProblemDetails } from '../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /companyregistrations/by-name
 */
export interface ByNameRequestBuilder extends BaseRequestBuilder<ByNameRequestBuilder> {
    /**
     * GetCompanyRegistrationsByName
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<CompanyRegistrationSummary[]>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     get(requestConfiguration?: RequestConfiguration<ByNameRequestBuilderGetQueryParameters> | undefined) : Promise<CompanyRegistrationSummary[] | undefined>;
    /**
     * GetCompanyRegistrationsByName
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<ByNameRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
/**
 * GetCompanyRegistrationsByName
 */
export interface ByNameRequestBuilderGetQueryParameters {
    name?: string;
}
/**
 * Uri template for the request builder.
 */
export const ByNameRequestBuilderUriTemplate = "{+baseurl}/companyregistrations/by-name?Name={Name}";
/**
 * Mapper for query parameters from symbol name to serialization name represented as a constant.
 */
const ByNameRequestBuilderGetQueryParametersMapper: Record<string, string> = {
    "name": "Name",
};
/**
 * Metadata for all the requests in the request builder.
 */
export const ByNameRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: ByNameRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createCompanyRegistrationSummaryFromDiscriminatorValue,
        queryParametersMapper: ByNameRequestBuilderGetQueryParametersMapper,
    },
};
/* tslint:enable */
/* eslint-enable */
